import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import MediaBrowserService from '../mediaBrowser/MediaBrowserService.jsx';

var PhotogalleryWidget = createReactClass({
  propTypes: {
    index: PropTypes.number,
    pictures: PropTypes.array,
    uuid: PropTypes.string,
    contentSpace: PropTypes.string,
  },

  getDefaultProps: function() {
    return {
      index: 0,
      pictures: [],
      uuid: '',
      contentSpace: null,
    };
  },

  didRemoveWidget() {
    this.props.didRemoveWidget(this.props.index);
  },

  moveWidgetUp() {
    this.props.moveWidget(this.props.index, 'up');
  },

  moveWidgetDown() {
    this.props.moveWidget(this.props.index, 'down');
  },

  removePhoto: function(event) {
    var index = event.target.getAttribute('data-index');
    if (index === null) {
      index = event.target.parentElement.getAttribute('data-index');
    }

    var r = window.confirm('Naozaj chcete odstrániť obrázok');
    if (r) {
      var object = this.getWidgetObject();
      object.pictures.splice(index, 1);
      this.props.changeObject(this.props.index, object);
    }
  },

  describePhoto: function(event) {
    var index = event.target.getAttribute('data-index');
    if (index === null) {
      index = event.target.parentElement.getAttribute('data-index');
    }

    var object = this.getWidgetObject();
    var value = prompt('Názov obrázka', object.pictures[index].name);
    if (value !== null) {
      object.pictures[index].name = value;
      this.props.changeObject(this.props.index, object);
    }
  },

  addNewPhoto: function() {
    var _this = this;
    var onFileSelect = function(response) {
      _this.onAddPicture(response);
      MediaBrowserService.closeMediaBrowser();
    };
    MediaBrowserService.openMediaBrowser(
      onFileSelect,
      null,
      this.props.mediaManager,
      true,
    );
  },

  getWidgetObject: function() {
    let pictures = [];
    if (typeof this.props.data.pictures !== 'undefined') {
      pictures = this.props.data.pictures;
    }
    return { type: 'photogallery', pictures: pictures, uuid: this.props.uuid };
  },

  onAddPicture: function(src) {
    var object = this.getWidgetObject();
    if (typeof src === 'string') {
      object.pictures.push({ uri: src });
    } else if (Array.isArray(src)) {
      src.forEach(uri => {
        object.pictures.push({ uri: uri });
      });
    }

    this.props.changeObject(this.props.index, object);
  },

  onPhotoClick: function(event) {
    var _this = this;
    var index = event.target.getAttribute('data-index');
    var onFileSelect = function(uri) {
      var object = _this.getWidgetObject();
      object.pictures[index].uri = uri;
      _this.props.changeObject(_this.props.index, object);
      MediaBrowserService.closeMediaBrowser();
    };
    MediaBrowserService.openMediaBrowser(
      onFileSelect,
      null,
      this.props.mediaManager,
      true,
    );
  },

  render: function() {
    var picturesHtml = [];
    if (this.props.data.pictures) {
      for (var i = 0; i < this.props.data.pictures.length; i++) {
        var picture = this.props.data.pictures[i];
        picturesHtml.push(
          <div key={i} className="col-xs-3 col-sm-3 col-md-one-fifth">
            <div className="img-thumb">
              <button
                data-index={i}
                onClick={this.removePhoto}
                className="btn btn-danger btn-sm"
              >
                <span className="fa fa-times" />
              </button>
              <button
                data-index={i}
                onClick={this.describePhoto}
                className="btn btn-edit btn-sm"
              >
                <span className="fa fa-pencil" />
              </button>
              <img
                data-index={i}
                style={{ cursor: 'pointer' }}
                onClick={this.onPhotoClick}
                alt=""
                className="powered-by img-responsive"
                src={
                  'https://data.tvkosice.sk/images/cm/168x168xmedia/' +
                  picture.uri
                }
              />
            </div>
          </div>,
        );
      }
    }
    return (
      <div
        data-index={this.props.index}
        style={{ clear: 'both' }}
        className="panel panel-default widget-body"
      >
        <div className="panel-heading">
          <div className="btn-group">
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetUp}
              disabled={this.props.index === 0}
            >
              <i className="fa fa-arrow-up" />
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetDown}
              disabled={this.props.isLast}
            >
              <i className="fa fa-arrow-down" />
            </button>
          </div>
          <span className="panel-title">
            <strong> {this.props.name}</strong>
          </span>
          <a
            onClick={this.didRemoveWidget}
            href="javascript:void(0);"
            className="btn btn-danger btn-sm pull-right"
          >
            <i className="fa fa-times" />
          </a>
        </div>
        <div className="panel-body">
          <div className="gallery">
            {picturesHtml}
            <div
              onClick={this.addNewPhoto}
              className="col-xs-3 col-sm-3 col-md-one-fifth"
            >
              <div className="img-thumb">
                <div className="add-image" style={{ height: '168px' }}>
                  <i className="fa fa-plus" />
                </div>
              </div>
            </div>
            <div style={{ clear: 'both' }} />
          </div>
        </div>
      </div>
    );
  },
});

export default PhotogalleryWidget;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleWidgets/ArticleWidgetPhotogallery.jsx